module.exports = __webpack_public_path__ + "8259be7e4e2b72bb25cfdf5805e58bd8.pdf";